import {AnimationBuilder} from "@angular/animations";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {animerBlinkMedRamme} from "../animasjoner";

export function fokuserPåFørsteFeltMedFeil(kontainer:HTMLElement, animationBuilder: AnimationBuilder) {
    const førsteFeil = kontainer.querySelector('mat-form-field.ng-invalid') as HTMLElement;
    //dersom feilen er knyttet til et input-element - gi dette fokus
    const inputfelt = førsteFeil.querySelector('input');
    if (erIkkeNil(inputfelt)) inputfelt.focus();

    //scroll til feilen og animer blinking (etter en liten forsinkelse slik at scrollingen er ferdig
    //#CF1D16 er $feil-200-hoved i lederplan-klient/src/styles/felles/farger.scss
    førsteFeil.scrollIntoView({block: 'center', behavior: 'smooth'})
    setTimeout(() => animationBuilder.build(animerBlinkMedRamme({bakgrunnsfarge: '#CF1D1650', rammefarge: '#CF1D16'})).create(førsteFeil).play(), 500);
}
